import React from "react";

const InputContainer = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  validationMessage,
  validationColor,
  buttonLabel,
  onButtonClick,
  type,
  options,
  autoComplete,
  passwordMask,
  inputStyle = {},
  inputReadonly = false,
}) => {
  const userAuth = localStorage.getItem("auth");
  const isReadOnly = label === "권한" && value === 5;
  const isAdmin = label === "권한" && userAuth === "Admin";
  const isAdminHospital = label === "병원" && userAuth === "Admin";

  return (
    <div className="input-container">
      <div className="input-row">
        <label htmlFor={name}>{label}</label>
        <div className="input-field">
          {type === "select" ? (
            <select name={name} value={value ?? ""} id={id} onChange={onChange} className="custom-select" disabled={isReadOnly || isAdmin || isAdminHospital}>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          ) : (
            <input
              autoComplete={autoComplete}
              type={type || "text"}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              style={
                passwordMask
                  ? {
                      WebkitTextSecurity: "disc", // Safari용 마스킹
                      textSecurity: "disc", // 표준 마스킹 속성 (일부 브라우저 지원)
                    }
                  : inputStyle
              }
              readOnly={inputReadonly}
            />
          )}
          {buttonLabel && (
            <button className="dashboard-content-button green-button popup-button" onClick={onButtonClick}>
              {buttonLabel}
            </button>
          )}
        </div>
      </div>
      {validationMessage && (
        <p className="validation-message" style={{ color: validationColor, fontWeight: "400" }}>
          {validationMessage}
        </p>
      )}
    </div>
  );
};

export default InputContainer;
